import React, { FC } from 'react'
import { Button, useTheme } from '@mui/material'
import LogoutIcon from '@mui/icons-material/Logout'
import { useNavigate } from 'react-router-dom'
import { useLogoutMutation } from '../../features/users'
import { useToast } from '../../contexts/ToastContext'

interface LogoutButtonProps {
  position?: 'fixed' | 'relative'
  bottom?: number
  right?: number
}

export const LogoutButton: FC<LogoutButtonProps> = ({
  position = 'fixed',
  bottom = 24,
  right = 24,
}) => {
  const navigate = useNavigate()
  const theme = useTheme()
  const logoutMutation = useLogoutMutation()
  const { showToast } = useToast()

  const handleLogout = () => {
    logoutMutation.mutate(undefined, {
      onSuccess: () => {
        // ローカルデータをクリア
        localStorage.clear()
        sessionStorage.clear()
        showToast('ログアウトしました。', 'success', 1500)
        // 成功メッセージを表示してから遷移
        setTimeout(() => {
          navigate('/login')
        }, 1500)
      },
      onError: (error) => {
        console.error('Logout failed:', error)
        showToast(
          'ログアウトに失敗しました。ログイン画面に戻ります。',
          'error',
          2000
        )
        // エラー時もクリア
        localStorage.clear()
        sessionStorage.clear()
        // セッションクリアのためログインページへ遷移
        setTimeout(() => {
          navigate('/login')
        }, 2000)
      },
    })
  }

  return (
    <Button
      variant="outlined"
      startIcon={<LogoutIcon sx={{ color: theme.palette.grey[600] }} />}
      onClick={handleLogout}
      disabled={logoutMutation.isPending}
      sx={{
        position,
        bottom,
        right,
        color: theme.palette.grey[600],
        borderWidth: '1px',
        borderColor: theme.palette.grey[400],
        fontWeight: 'bold',
        px: 2.5,
        py: 0.8,
        backgroundColor: 'white',
        '&:hover': {
          backgroundColor: theme.palette.grey[100],
          borderColor: theme.palette.grey[500],
          borderWidth: '1px',
        },
        transition: 'all 0.2s ease-in-out',
      }}
    >
      ログアウト
    </Button>
  )
}
